import * as React from 'react';

// Material UI
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import { Typography, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import Autocomplete from '@mui/material/Autocomplete';
// Modal
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// Estilos 
import { styled } from '@mui/material/styles';

// Icons UI
import CloseIcon from '@mui/icons-material/Close';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
// import BorderColorIcon from '@mui/icons-material/BorderColor';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
	'& .MuiDialogContent-root': {
		padding: theme.spacing(2),
	},
	'& .MuiDialogActions-root': {
		padding: theme.spacing(1),
	},
}));

export default function AddCortina(params) {
	let baseReset = {
		tipo: "articulo",
		cantidad: 1,
		nombre: "",
		datos: {
			descripcion: "",
			datosextra: "",
		},
		precio: {
			precioUnitario: 0,
			subtotal: 0,
			descuento: 0,
			subtotal1: 0,
			descuentoAd: 0,
			total: 0
		},
		precioDistribuidor: {
			precioUnitario: 0,
			subtotal: 0,
			descuento: 0,
			subtotal1: 0,
			descuentoAd: 0,
			total: 0
		}
	}

	const [baseArticulo, setBaseArticulo] = React.useState({
		tipo: "articulo",
		cantidad: 1,
		nombre: "",
		datos: {
			descripcion: "",
			datosextra: "",
		},
		precio: {
			precioUnitario: 0,
			subtotal: 0,
			descuento: 0,
			subtotal1: 0,
			descuentoAd: 0,
			total: 0
		},
		precioDistribuidor: {
			precioUnitario: 0,
			subtotal: 0,
			descuento: 0,
			subtotal1: 0,
			descuentoAd: 0,
			total: 0
		}
	})

	const [open, setOpen] = React.useState(false);
	const handleOpen = () => { setOpen(true); setBaseArticulo(params.edit); } // setBase(params.edit);
	const handleClose = () => setOpen(false);

	const handleCancel = () => {
		setBaseArticulo({ ...baseReset })
		handleClose()
	}

	// Guarda el Articulo
	const handleAceptar = () => {
		// console.log(baseArticulo.nombre);

		if (!baseArticulo.nombre) {
			params.toast.error('Te falta agregar el nombre.')
			return false
		} else if (params.tieneStringVacio(baseArticulo.precio)) {
			params.toast.error('Te faltan Precio que agregar.')
			return false
		}

		params.handleEditArticle(params.articleId, baseArticulo)
		setBaseArticulo(baseReset)

		handleClose()
	}

	const checkValue = (attr) => {
		return !attr || attr === 0 ? 0 : attr
	}

	const porcent = (part, total) => {
		let xpart = checkValue(part)
		let xtotal = checkValue(total)
		return total - ((xpart * xtotal) / 100)
	}

	const roundDecimal = (number) => {
		let total = checkValue(number)
		total = parseFloat(total)
		let redondeado = parseFloat(total.toFixed(2))
		return redondeado;
	}


	const handleEditData = (e) => {
		const { id, value } = e.target;
		const tb = {
			...baseArticulo,
			precio: { ...baseArticulo.precio }, // Copia profunda para campos anidados
			precioDistribuidor: { ...baseArticulo.precioDistribuidor }, // Copia profunda para campos anidados
		};


		switch (id) {


			case "nombre":
				tb.nombre = value; // Eliminar espacios innecesarios
				break;

			case "descripcion":
				tb.datos.descripcion = value;
				break;

			case "datosextra":
				tb.datos.datosextra = value;
				break;


			case "cantidad":
				tb.cantidad = value;

				tb.precio.subtotal = checkValue(value || 0) * tb.precio.precioUnitario;
				tb.precio.subtotal1 = roundDecimal(porcent(tb.precio.descuento, tb.precio.subtotal))
				tb.precio.total = roundDecimal(porcent(tb.precio.descuentoAd, tb.precio.subtotal1)).toLocaleString("en-US")

				tb.precioDistribuidor.subtotal1 = roundDecimal(porcent(tb.precioDistribuidor.descuento, tb.precio.subtotal))
				tb.precioDistribuidor.total = roundDecimal(porcent(tb.precioDistribuidor.descuentoAd, tb.precioDistribuidor.subtotal1)).toLocaleString("en-US")

				break;

			case "precioUnitario":
				tb.precio.precioUnitario = value;

				tb.precio.subtotal = tb.cantidad * checkValue(value || 0);
				tb.precio.subtotal1 = roundDecimal(porcent(tb.precio.descuento, tb.precio.subtotal))
				tb.precio.total = roundDecimal(porcent(tb.precio.descuentoAd, tb.precio.subtotal1)).toLocaleString("en-US")

				tb.precioDistribuidor.subtotal1 = roundDecimal(porcent(tb.precioDistribuidor.descuento, tb.precio.subtotal))
				tb.precioDistribuidor.total = roundDecimal(porcent(tb.precioDistribuidor.descuentoAd, tb.precioDistribuidor.subtotal1)).toLocaleString("en-US")
				
				break;

			case "descuento":
				tb.precio.descuento = value;

				tb.precio.subtotal = tb.cantidad * tb.precio.precioUnitario;;
				tb.precio.subtotal1 = roundDecimal(porcent(value, tb.precio.subtotal))
				tb.precio.total = roundDecimal(porcent(tb.precio.descuentoAd, tb.precio.subtotal1)).toLocaleString("en-US")

				break;

			case "descuentoAd":
				tb.precio.descuentoAd = value;

				tb.precio.subtotal = tb.cantidad * tb.precio.precioUnitario;;
				tb.precio.subtotal1 = roundDecimal(porcent(tb.precio.descuento, tb.precio.subtotal))
				tb.precio.total = roundDecimal(porcent(value, tb.precio.subtotal1)).toLocaleString("en-US")

				break;

			case "descuentoDistribuidor":
				tb.precioDistribuidor.descuento = value;

				tb.precio.subtotal = tb.cantidad * tb.precio.precioUnitario;;
				tb.precioDistribuidor.subtotal1 = roundDecimal(porcent(value, tb.precio.subtotal))
				tb.precioDistribuidor.total = roundDecimal(porcent(tb.precioDistribuidor.descuentoAd, tb.precioDistribuidor.subtotal1)).toLocaleString("en-US")
				
				break;

			case "descuentoAdDistribuidor":
				tb.precioDistribuidor.descuentoAd = value;

				tb.precio.subtotal = tb.cantidad * tb.precio.precioUnitario;;
				tb.precioDistribuidor.subtotal1 = roundDecimal(porcent(tb.precioDistribuidor.descuento, tb.precio.subtotal))
				tb.precioDistribuidor.total = roundDecimal(porcent(value, tb.precioDistribuidor.subtotal1)).toLocaleString("en-US")
				
				break;

			default:
				console.warn(`Campo no manejado: ${id}`);
				break;
		}

		setBaseArticulo(tb); // Actualizar estado con el cambio
	};

	// Procesar y formatear los valores al desenfocar
	const handleBlur = (e) => {
		const { id, value } = e.target;
		const tb = {
			...baseArticulo,
			precio: { ...baseArticulo.precio }, // Copia profunda
		};

		if (id === "precio") {
			const parsedValue = parseFloat(value.replace(/,/g, "")) || 0; // Convertir a número
			tb.precio.precio = parsedValue; // Actualizar el estado con el valor procesado
			tb.precio.total =
				roundDecimal(
					porcent(tb.precio.descuento, parsedValue) * checkValue(tb.cantidad || 0)
				).toLocaleString("en-US"); // Recalcular el total
		}

		setBaseArticulo(tb); // Actualizar estado procesado
	};





	return (
		<div>
			{/* <Button className='ml-4' variant='outlined' color='ochre' onClick={handleOpen} startIcon={<LibraryAddIcon />}>Articulo</Button> */}
			<IconButton onClick={handleOpen} color="blueRA" aria-label="add to shopping cart">
				<BorderColorIcon />
			</IconButton>
			<BootstrapDialog
				maxWidth='md'
				// fullScreen
				open={open}
				onClose={handleClose}
			>
				{/* HEADER */}
				<DialogTitle>Agregar Articulo</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={handleClose}
					sx={(theme) => ({
						position: 'absolute',
						right: 8,
						top: 8,
						color: theme.palette.grey[500],
					})}
				>
					<CloseIcon />
				</IconButton>

				{/* BODY */}
				<DialogContent dividers className='barscroll pb-10'>
					<form noValidate autoComplete="off">
						<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
							<Grid size={{ xs: 12, sm: 12, md: 12 }} className="flex items-center">
								<Grid container spacing={{ xs: 2, md: 2 }} rowSpacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
									<Grid size={{ xs: 12, sm: 12, md: 12 }} className="flex items-center">
										<Typography color={"blueRA"} className='ml-4'>Datos Generales:</Typography>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 3 }} className="flex items-center">
										<TextField
											fullWidth
											id="cantidad"
											name="cantidad"
											label="Cantidad"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											inputProps={{ min: 1 }}
											value={baseArticulo.cantidad}
											onChange={handleEditData}
										/>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 9 }} className="flex items-center">
										<TextField
											fullWidth
											id="nombre"
											name="nombre"
											label="Nombre"
											variant="outlined"
											type='text'
											color={"blueRA"}
											size="small"
											inputProps={{ min: 1 }}
											value={baseArticulo.nombre}
											onChange={handleEditData}
										/>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center">
										<TextField
											fullWidth
											id="descripcion"
											name="descripcion"
											label="Descripcion"
											variant="outlined"
											type='text'
											color={"blueRA"}
											size="small"
											inputProps={{ min: 1 }}
											value={baseArticulo.datos.descripcion}
											onChange={handleEditData}
										/>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center">
										<TextField
											fullWidth
											id="datosextra"
											name="datosextra"
											label="Datos Extra"
											variant="outlined"
											type='text'
											color={"blueRA"}
											size="small"
											inputProps={{ min: 1 }}
											value={baseArticulo.datos.datosextra}
											onChange={handleEditData}
										/>
									</Grid>
									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Divider className='my-7' />
									</Grid>

									<Grid size={{ xs: 4, sm: 10, md: 12 }} className="flex items-center">
										<Typography color={"blueRA"} className='ml-4'>Precio:</Typography>
									</Grid>

									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center">
										<TextField
											fullWidth
											id="precioUnitario"
											name="precioUnitario"
											label="Precio Unitario"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											value={baseArticulo.precio.precioUnitario}
											onChange={handleEditData}
											slotProps={{
												input: {
													startAdornment: <InputAdornment position="start">$</InputAdornment>,
												},
											}}
										/>
									</Grid>

									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center justify-center">
										<Typography variant='span' className='mr-3'>SubTotal: </Typography>
										<Typography variant='h6' color='ochre'>${baseArticulo.precio.subtotal ? baseArticulo.precio.subtotal : 0}</Typography>										
									</Grid>

									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Divider className='my-7' />
									</Grid>

									<Grid size={{ xs: 4, sm: 10, md: 12 }} className="flex items-center">
										<Typography color={"blueRA"} className='ml-4'>Descuento Cliente:</Typography>
									</Grid>

									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center">
										<TextField
											fullWidth
											id="descuento"
											name="descuento"
											label="Descuento General"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											value={baseArticulo.precio.descuento}
											onChange={handleEditData}
											slotProps={{
												input: {
													endAdornment: <InputAdornment position="end">%</InputAdornment>,
												},
											}}
										/>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center justify-center">
										<Typography variant='span' className='mr-3'>SubTotal: </Typography>
										<Typography variant='h6' color=''>${baseArticulo.precio.total ? baseArticulo.precio.total : 0}</Typography>										
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center">
										<TextField
											fullWidth
											id="descuentoAd"
											name="descuentoAd"
											label="Descuento Adicional"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											value={baseArticulo.precio.descuentoAd}
											onChange={handleEditData}
											slotProps={{
												input: {
													endAdornment: <InputAdornment position="end">%</InputAdornment>,
												},
											}}
										/>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center justify-center">
										<Typography variant='span' className='mr-3'>Total Cliente: </Typography>
										<Typography variant='h6' color='ochre'>${baseArticulo.precio.total ? baseArticulo.precio.total : 0}</Typography>										
									</Grid>
									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Divider className='my-7' />
									</Grid>

									<Grid size={{ xs: 4, sm: 10, md: 12 }} className="flex items-center">
										<Typography color={"blueRA"} className='ml-4'>Descuento Distribuidor:</Typography>
									</Grid>

									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center">
										<TextField
											fullWidth
											id="descuentoDistribuidor"
											name="descuentoDistribuidor"
											label="Descuento General"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											value={baseArticulo.precioDistribuidor.descuento}
											onChange={handleEditData}
											slotProps={{
												input: {
													endAdornment: <InputAdornment position="end">%</InputAdornment>,
												},
											}}
										/>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center justify-center">
										<Typography variant='span' className='mr-3'>SubTotal: </Typography>
										<Typography variant='h6' color='ochre'>${baseArticulo.precioDistribuidor.total ? baseArticulo.precioDistribuidor.total : 0}</Typography>										
									</Grid>

									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center">
										<TextField
											fullWidth
											id="descuentoAdDistribuidor"
											name="descuentoAdDistribuidor"
											label="Descuento Adicional"
											variant="outlined"
											type='number'
											color={"blueRA"}
											size="small"
											value={baseArticulo.precioDistribuidor.descuentoAd}
											onChange={handleEditData}
											slotProps={{
												input: {
													endAdornment: <InputAdornment position="end">%</InputAdornment>,
												},
											}}
										/>
									</Grid>
									<Grid size={{ xs: 4, sm: 5, md: 6 }} className="flex items-center justify-center">
										<Typography variant='span' className='mr-3'>Total Distribuidor: </Typography>
										<Typography variant='h6' color='ochre'>${baseArticulo.precioDistribuidor.total ? baseArticulo.precioDistribuidor.total : 0}</Typography>										
									</Grid>

									<Grid size={{ xs: 4, sm: 10, md: 12 }} >
										<Divider className='mt-7' />
									</Grid>


								</Grid>
							</Grid>
							{/* <Grid size={{ xs: 12, sm: 4, md: 4 }} className="flex items-center p-6">
								<div className='flex items-center'>
									<Typography variant='h5' className='mr-2' color={"ochre"}>Total:</Typography>
									${baseArticulo.precio.total}
								</div>
							</Grid> */}
						</Grid>
					</form>
				</DialogContent>

				{/* FOOTER */}
				<DialogActions className='flex justify-between px-5'>
					<div></div>
					<div>
						<Button className='mr-5' color='ochre' variant="contained" onClick={handleAceptar}>Aceptar</Button>
						<Button color='error' variant="outlined" onClick={handleCancel}>Cancelar</Button>
					</div>
				</DialogActions>
			</BootstrapDialog>
		</div>
	)
}
